  
(function(){
  document.addEventListener('DOMContentLoaded', function() {

    /*
    * start code for hover menu open
    */
    (function () {
      const inlineMenu = document.querySelector(".header__inline-menu");
      if (!inlineMenu) return;

      const DELAY = 500;
      const GAP = 13;

      function setPadding(item) {
        const secondLevelMenu = item.querySelector(".second_level_menu");
        if (!secondLevelMenu) return;

        const subBlock = secondLevelMenu.querySelector(".sub_3_level");
        if (!subBlock) return;

        const rect = secondLevelMenu.getBoundingClientRect();
        const rightLength = window.innerWidth - rect.left - rect.width - GAP;
        subBlock.style.paddingRight = Math.max(0, rightLength) + "px";
      }

      const items = inlineMenu.querySelectorAll("details");

      items.forEach((item) => {
        let timer;

        const open = () => {
          clearTimeout(timer);
          item.setAttribute("open", "");
          requestAnimationFrame(() => setPadding(item));
        };

        const close = () => {
          timer = setTimeout(() => item.removeAttribute("open"), DELAY);
        };

        item.addEventListener("mouseenter", open);
        item.addEventListener("mouseleave", close);

        const panel = item.querySelector("ul.mega-menu__list");
        if (panel) {
          panel.addEventListener("mouseenter", open);
          panel.addEventListener("mouseleave", close);
        }
      });

      let resizeTimer;
      window.addEventListener("resize", () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
          items.forEach((item) => {
            if (item.hasAttribute("open")) setPadding(item);
          });
        }, 150);
      });
    })();
    /*
    * end start code for hover menu open
    */

    // js/custom-element/section/cart/free-shipping-bar.js
    var FreeShippingBar = class extends HTMLElement { 
      connectedCallback() {
        document.documentElement.addEventListener("cart:updated", this._onCartUpdated.bind(this));
      }
      get threshold() {
        return parseFloat(this.getAttribute("threshold"));
      }
      _onCartUpdated(event) {
        this.style.setProperty("--progress", Math.min(parseFloat(event.detail["cart"]["total_price"]) / this.threshold, 1));
      }
    };
    window.customElements.define("free-shipping-bar", FreeShippingBar);
  

    
    var playButton = document.querySelectorAll('.banner_section .video-section__poster');
    if ( playButton ) {
      setTimeout(function() {
        playButton.forEach( elem => {
          elem.click();
          window.scrollBy(0,2);
        });
        document.addEventListener("scroll", (event) => {
          var videoelem = document.querySelectorAll('.banner_section video');
          videoelem.forEach( elem => {
            elem.play();
          });
        });
        document.addEventListener("touchstart", (event) => {
          var videoelem = document.querySelectorAll('.banner_section video');
          videoelem.forEach( elem => {
            elem.play();
          });
        });
      }, 100);
    }

    var playButton = document.querySelectorAll('#product-grid .video-section .video-section__poster');
    if ( playButton ) {
      setTimeout(function() {
        playButton.forEach( elem => {
          elem.click();
          window.scrollBy(0,2);
        });
        document.addEventListener("scroll", (event) => {
          var videoelem = document.querySelectorAll('#product-grid .video-section video');
          videoelem.forEach( elem => {
            // window.scrollBy(0,2);
            elem.play();
          });
        });
        document.addEventListener("touchstart", (event) => {
          var videoelem = document.querySelectorAll('#product-grid .video-section video');
          videoelem.forEach( elem => {
            // window.scrollBy(0,2);
            elem.play();
          });
        });
      }, 100);
    }
    
    window.initJsSlideProduct = () => {

  // Данные вариантов — парсим ДО создания слайдеров,
  // т.к. Swiper при инициализации уже вызывает changeVariantByImage
  let productCur = document.querySelector('[data-tb-variants-json]');
  if (productCur) {
    productCur = JSON.parse(productCur.getAttribute('data-tb-variants-json'));
  }

  // Запускает видео в активном слайде ГЛАВНОГО слайдера конкретного продукта
  function playActiveVideo(container) {
    const activeSlide = container.querySelector('.js-product-main-slider .swiper-slide-active');
    if (!activeSlide) return;

    const poster = activeSlide.querySelector('.deferred-media__poster');
    if (poster) {
      poster.click();
      setTimeout(() => {
        activeSlide.querySelector('video')?.play().catch(err => console.log(err));
      }, 1000);
      return;
    }

    activeSlide.querySelector('video')?.play().catch(err => console.log(err));
  }

  const containerProduct = document.querySelectorAll('product-info');

  containerProduct.forEach(elem => {
    const mainItem = elem.querySelector('.js-product-main-slider');
    if (!mainItem) return;

    const thumbItem = elem.querySelector('.js-product-thumbnail-slider');
    let sliderThumbnail = null;

    if (thumbItem) {
      sliderThumbnail = new Swiper(thumbItem, {
        spaceBetween: 6,
        mousewheel: true,
        slidesPerView: 7,
        threshold: 8, // свайп начинается только после сдвига на 8px — дрожание мыши не ломает клик
        on: {
          slideChangeTransitionEnd: function () {
            playActiveVideo(elem);
          }
        },
        breakpoints: {
          320: {
            slidesPerView: 4,
          },
          640: {
            slidesPerView: 7,
          },
          750: {
            direction: 'vertical',
            autoHeight: true,
          }
        }
      });
    }

    window.galleryMain = new Swiper(mainItem, {
      initialSlide: parseInt(mainItem.dataset.type, 10) > 1 ? 1 : 0,
      slidesPerView: 1,
      threshold: 8, // зона допуска: сдвиг < 8px считается кликом, не свайпом
      thumbs: sliderThumbnail ? { swiper: sliderThumbnail } : undefined,
      navigation: {
        // массив: штатные стрелки + стрелки мобильного счётчика
        nextEl: [mainItem.querySelector('.swiper-button-next'), elem.querySelector('.js-counter-next')].filter(Boolean),
        prevEl: [mainItem.querySelector('.swiper-button-prev'), elem.querySelector('.js-counter-prev')].filter(Boolean),
      },
      // счётчик "1/3" (виден только на мобильных — см. CSS)
      pagination: {
        el: elem.querySelector('.js-counter-fraction'),
        type: 'fraction',
      },
      on: {
        slideChangeTransitionEnd: function () {
          changeVariantByImage(this);
          playActiveVideo(elem);
        }
      }
    });
  });

  /**
   * Смена слайда при выборе варианта
   */
  function variantImage(val) {
    if (!productCur || !window.galleryMain) return;

    const selectedVariantId = parseInt(val, 10);
    const variant = productCur.find(v => v.id === selectedVariantId);
    const mediaId = variant?.featured_media?.id;
    if (!mediaId) return;

    const slide = document.querySelector(`product-info .main-slider [data-for-slick="${mediaId}"]:not(.swiper-slide-duplicate)`);
    if (!slide) return;

    const ariaLabel = slide.getAttribute('aria-label'); // формат "3/7"
    const slideNumber = parseInt(ariaLabel?.split('/')[0], 10);
    if (!isNaN(slideNumber)) {
      window.galleryMain.slideTo(slideNumber - 1);
    }
  }

  const initialColorVariant = document.querySelector('product-info .product-variant-id');
  initialColorVariant?.addEventListener('change', function () {
    if (this.value) variantImage(this.value);
  });

  /**
   * Смена варианта при перелистывании слайдов
   */
  function changeVariantByImage(swiper) {
    if (!productCur) return;

    const activeSlide = swiper.el.querySelector('.swiper-slide-active');
    const mediaId = parseInt(activeSlide?.getAttribute('data-for-slick'), 10);
    if (!mediaId) return;

    // первый доступный вариант с этим изображением
    const variant = productCur.find(v => v?.featured_media?.id === mediaId && v.available === true);
    if (!variant) return;

    variant.options.forEach(option => {
      const input = document.querySelector(`input[value="${CSS.escape(option)}"]`);
      // клик только если опция ещё не выбрана — иначе цикл:
      // слайд -> клик -> смена варианта -> слайд -> клик -> ...
      if (input && !input.checked) {
        input.nextElementSibling?.click(); // label после input
      }
    });
  }
};
window.initJsSlideProduct();

    window.initCompareSlider = function() {
      let compareBlock = document.querySelector('.compare_products');
      if (!compareBlock) return false;

      let slides = compareBlock.querySelectorAll('.item_product');
      let countOfSlides = compareBlock.dataset.columns;
      if (slides.length < parseInt(countOfSlides, 10)) return false;

      let wrapper = compareBlock.closest('.compare_block');
      let navigation = wrapper ? {
        nextEl: wrapper.querySelector('.swiper-button-next'),
        prevEl: wrapper.querySelector('.swiper-button-prev'),
      } : false;

      new Swiper(compareBlock, {
        spaceBetween: 40,
        slidesPerView: 3,
        freeMode: true,
        breakpoints: {
          320: { slidesPerView: 1.2 },
          750: { slidesPerView: 1, navigation },
          1024: { slidesPerView: 3, navigation },
        }
      });
    }
    window.initCompareSlider();

   

    /*
      * slider with products
      */
    window.initRecentlyViwedProducsSlider = () => {
      
      let relatedProducts = document.querySelectorAll('.recently-viewed-swiper');
     if ( ! relatedProducts ) return false;
      relatedProducts.forEach(elem => {
          if ( ! elem ||  
             elem.querySelectorAll('.swiper-slide') && 
             elem.querySelectorAll('.swiper-slide').length < 2 ) return false;
          new Swiper(elem, {
            slidesPerView: 2.5,
            spaceBetween: 21,
            freeMode: false,
            navigation: {
              nextEl: elem.closest('recently-viewed-products').querySelector('.swiper-next-button'),
              prevEl: elem.closest('recently-viewed-products').querySelector('.swiper-prev-button'),
            },
            scrollbar: {
              el: elem.closest('recently-viewed-products').querySelector('.swiper-scrollbar'),
              draggable: true,
            },
            breakpoints: {
              320: {
                slidesPerView: 1,
                centeredSlides: false,
                spaceBetween: 5,
                // initialSlide: 1,
                pagination: {
                  type: 'bullets',
                  el: elem.closest('recently-viewed-products').querySelector(".swiper-pagination"),
                  clickable: true,
                },
              },
              640: {
                slidesPerView: 2,
                spaceBetween: 2
              },
              768: {
                slidesPerView: 2.5,
                spaceBetween: 21,
              }
            }
          });
      });
    } 

    // js/custom-element/section/product-recommendations/recently-viewed-products.js
  var RecentlyViewedProducts = class extends HTMLElement { 
    async connectedCallback() {
      if (this.searchQueryString === "") {
        return; 
      }
      const response = await fetch(`${window.searchUrl}?type=product&q=${this.searchQueryString}&section_id=${this.sectionId}`);
      const div = document.createElement("div");
      div.innerHTML = await response.text();
      const recentlyViewedProductsElement = div.querySelector("recently-viewed-products");
      if (recentlyViewedProductsElement.hasChildNodes()) {
        this.innerHTML = recentlyViewedProductsElement.innerHTML;

        if ( window.initRecentlyViwedProducsSlider ) {
          window.initRecentlyViwedProducsSlider(); 
        }
      }
    }
    get searchQueryString() {
      const items = JSON.parse(localStorage.getItem("theme:recently-viewed-products") || "[]");
      if (this.hasAttribute("exclude-product-id") && items.includes(parseInt(this.getAttribute("exclude-product-id")))) {
        items.splice(items.indexOf(parseInt(this.getAttribute("exclude-product-id"))), 1);
      }
      return items.map((item) => "id:" + item).slice(0, this.productsCount).join(" OR ");
    }
    get sectionId() {
      return this.getAttribute("section-id");
    }
    get productsCount() {
      return this.getAttribute("products-count") || 7;
    }
  };
  window.customElements.define("recently-viewed-products", RecentlyViewedProducts);

  /**
   * transfer additional sections iside product-info block
   */
  function transferSectionProductPage() {
    if ( window.innerWidth < 1024 ) return false;
 
    let sections = ['.related-products-section', '.shopify-section--recently-viewed-products'];
    let targetContainer = document.querySelector('product-info .additional_blocks');
    if ( ! targetContainer ) return false;

    sections.forEach(element => {
      let item = document.querySelector(element);
      if ( item ) {
        targetContainer.append(item);
      }
    });
  }
  transferSectionProductPage();


  window.sliderProductCard = function () {
      const sliderProductCard = new Swiper('cart-drawer-recommendations .slider--card:not(.swiper-initialized)', {
        slidesPerView: 1,
        //slidesPerView: 'auto',
        spaceBetween: 0,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        pagination: {
          type: 'bullets',
          el: ".swiper-pagination",
          clickable: true,
        },
        grabCursor: false, // pointer
        //thumbs: {
          //swiper: sliderThumbs, // thumb slider name
        //},
        breakpoints: {
          0: {
            pagination: {
            type: 'progressbar',
            el: ".swiper-pagination",
            clickable: false,
          },
          },
          750: {
            pagination: {
              type: 'bullets',
              clickable: true,
            },
          },
        },
        on: {
          init: function () {
            if(this.slides.length < 2) {
              this.el.classList.add('disabled');
            }
          }
        },
      });
    }

    /**
     * togle for mobile menu
     */
    function toggleFooterTitles() {
      let titles = document.querySelectorAll('.footer__content-middle .footer-block__heading');
      if ( ! titles ) return false;
      titles.forEach(elem => {
        elem.addEventListener('click', function(e) {
          e.preventDefault();
          elem.classList.toggle('active');
        });
      });
    }
    toggleFooterTitles();

     window.sliderProductType = function () {
      return false;
      if ( window.innerWidth > 750 ) return false;
      let typeSwitch = document.querySelectorAll('product-info .switch-slider .swiper');
      if ( ! typeSwitch ) return false;
      typeSwitch.forEach(elem => {
        new Swiper(elem, {
          slidesPerView: 'auto',
          spaceBetween: 12,
          navigation: {
            nextEl: elem.closest('.switch-slider').querySelector('.swiper-button-next'),
            prevEl: elem.closest('.switch-slider').querySelector('.swiper-button-prev'),
          },
          freeMode: {
            enabled: true
          },
          // breakpoints: {
          //   0: {
          //   },
          //   750: {
          //   },
          // },
        });
      });
    }

    window.sliderProductType();

    window.sliderProductButton = function () {
      return false;
      if ( window.innerWidth > 750 ) return false;
      let typeSwitch = document.querySelectorAll('product-info .buttons_var_swiper.swiper');
      if ( ! typeSwitch ) return false;
      typeSwitch.forEach(elem => {
        new Swiper(elem, {
          slidesPerView: 'auto',
          spaceBetween: 12,
          navigation: {
            nextEl: elem.closest('fieldset').querySelector('.swiper-button-next'),
            prevEl: elem.closest('fieldset').querySelector('.swiper-button-prev'),
          },
          freeMode: {
            enabled: true
          },
          // breakpoints: {
          //   0: {
          //   },
          //   750: {
          //   },
          // },
        });
      });
    }

    window.sliderProductButton();

    
    window.articlesSliderProductPage = function () {
      let articlesSliderProductPage = document.querySelectorAll('.related-articles-wrapper.swiper');
      if ( ! articlesSliderProductPage ) return false;
      articlesSliderProductPage.forEach(elem => {
        if ( ! elem ||  
             elem.querySelectorAll('.swiper-slide') && 
             elem.querySelectorAll('.swiper-slide').length < 2 ) return false;
        new Swiper(elem, {
          slidesPerView: 3,
          spaceBetween: 25,
          breakpoints: {
            0: {
              slidesPerView: 1.2,
              // pagination: {
              //   type: 'bullets',
              //   el: elem.querySelector(".swiper-pagination"),
              //   clickable: true,
              // },
            },
            750: {
            },
          },
          on: {
            init: function () {
              if(this.slides.length < 2) {
                this.el.classList.add('disabled');
              }
            }
          },
        });
      });
    }
    window.articlesSliderProductPage();


    // function megaMenuHandle() {
    //   const menus = document.querySelectorAll('.mega-menu');
    //   if ( ! menus.length ) return false;

    //   menus.forEach(menu => {
    //     const secondLevelMenu = menu.querySelectorAll('.second_level_menu');
    //     if ( ! secondLevelMenu.length ) return;

    //     secondLevelMenu.forEach(elem => {
    //       elem.addEventListener('click', function(e) {
    //         e.preventDefault();

    //         secondLevelMenu.forEach(item => {
    //           item.classList.remove('active');
    //         });
    //         elem.classList.add('active');

    //         const rect1 = secondLevelMenu[0].getBoundingClientRect();
    //         const viewportWidth = window.innerWidth;
    //         const rightLength = viewportWidth - rect1.left - rect1.width - 13;

    //         const subBlock = elem.querySelector('.sub_3_level');
    //         if ( subBlock ) {
    //           subBlock.style.paddingRight = rightLength + 'px';
    //         }
    //       });
    //     });
    //   });
    // }
    // megaMenuHandle();

    function setPaddingMegamenu() {
      // debugger;
      let megaMenuDetails = document.querySelectorAll('details.mega-menu');
      if ( !megaMenuDetails ) return false;
      megaMenuDetails.forEach(elem => {
        elem.addEventListener('click', function() {
          setTimeout(function() {
            let secondLevelMenu = document.querySelector('.second_level_menu:first-child');
            const rect1 = secondLevelMenu.getBoundingClientRect();
            console.log(rect1);
            const distanceToLeft = rect1.left;
            const viewportWidth = window.innerWidth;
            console.log(viewportWidth);
            let rightLength = viewportWidth - rect1.left - rect1.width - 13;
            console.log(rightLength);
            let subBlock = secondLevelMenu.querySelector('.sub_3_level');
            if ( subBlock ) {
              subBlock.style.paddingRight = rightLength + 'px';
            }
          }, 100);
          
        });
      });
    }
    setPaddingMegamenu();
    
    class FirinTableGrid extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.buttons = this.querySelectorAll('.firin-tabs-nav-button');
        this.contents = this.querySelectorAll('.firin-tabs-content');
        this.setupEventListeners();
      }

      setupEventListeners() {
        this.buttons.forEach((button) => {
          button.addEventListener('click', () => {
            const tabId = button.getAttribute('data-tab');
            console.log(tabId);
            this.switchTab(tabId);
          });
        });
      }

      switchTab(tabId) {
        this.buttons.forEach((btn) => {
          const btnTabId = btn.getAttribute('data-tab');
          if (btnTabId === tabId) {
            btn.classList.add('active');
            btn.setAttribute('aria-selected', 'true');
          } else {
            btn.classList.remove('active');
            btn.setAttribute('aria-selected', 'false');
          }
        });

        this.contents.forEach((content) => {
          const contentTabId = content.getAttribute('data-tab-content');
          if (contentTabId === tabId) {
            content.classList.add('active');
          } else {
            content.classList.remove('active');
          }
        });
      }
    }

    if (!customElements.get('firin-table-grid')) {
      customElements.define('firin-table-grid', FirinTableGrid);
    }

    function tabsRichText() {
      const container = document.querySelector('.rich-text-container-tab');
      if (!container) return;
      
      const buttons = container.querySelectorAll('.tab-button');
      const blocks = container.querySelectorAll('.tab-item-block');

      buttons.forEach((button) => {
        button.addEventListener('click', () => {
          const target = button.dataset.tabTarget;

          // Переключаем активную кнопку
          buttons.forEach((btn) => btn.classList.remove('active'));
          button.classList.add('active');

          // Показываем только нужные блоки
          blocks.forEach((block) => {
            if (block.dataset.tabCategory === target) {
              block.classList.add('active');
            } else {
              block.classList.remove('active');
            }
          });
        });
      });
    }
    tabsRichText();
    
//    /**
//  * card-color-slider.js
//  * Global custom element for the "N colors" mini slider in product cards.
//  * Include ONCE in layout/theme.liquid:
//  *   <script src="{{ 'card-color-slider.js' | asset_url }}" defer="defer"></script>
//  * Must load AFTER Swiper (or Swiper must also be deferred and included earlier).
//  */
// (() => {
//   if (customElements.get('color-slider')) return;

//   class ColorSlider extends HTMLElement {
//     connectedCallback() {
//       // Guard against upgrade-before-children-parsed (streaming parser)
//       // and against re-connection after AJAX re-render.
//       if (this.initialized) return;
//       if (!this.querySelector('.card-color-slider__toggle')) {
//         document.addEventListener('DOMContentLoaded', () => this.init(), { once: true });
//         return;
//       }
//       this.init();
//     }

//     init() {
//       if (this.initialized) return;
//       this.initialized = true;

//       this.toggle = this.querySelector('.card-color-slider__toggle');
//       this.wrap = this.querySelector('.card-color-slider__wrap');
//       this.swiperEl = this.querySelector('.card-color-slider__swiper');
//       this.prev = this.swiperEl.querySelector('.swiper-button-prev');
//       this.next = this.swiperEl.querySelector('.swiper-button-next');
//       this.cardWrapper = this.closest('.card-wrapper');
//       this.cardImg = this.cardWrapper
//         ? this.cardWrapper.querySelector('.card__media .media img')
//         : null;

//       if (this.cardImg) {
//         this.orig = {
//           src: this.cardImg.getAttribute('src'),
//           srcset: this.cardImg.getAttribute('srcset')
//         };
//       }

//       // Real hover only. On touch devices the browser emulates
//       // mouseenter right before click — opening here would make the tap's
//       // click land on the slide that replaced the button.
//       this.hoverCapable = window.matchMedia('(hover: hover)').matches;

//       this.toggle.addEventListener('click', () => this.open());
//       if (this.hoverCapable) {
//         this.toggle.addEventListener('mouseenter', () => this.open());
//       }

//       // Anti-jitter: delayed close, cancelled if the cursor comes right back.
//       this.addEventListener('mouseleave', () => {
//         this.closeTimer = setTimeout(() => this.close(), 150);
//       });
//       this.addEventListener('mouseenter', () => {
//         clearTimeout(this.closeTimer);
//       });

//       this.querySelectorAll('.card-color-slider__item').forEach((link) => {
//         // Anti-jitter: swap only if the cursor actually rests on a slide.
//         if (this.hoverCapable) {
//           link.addEventListener('mouseenter', () => {
//             this.swapTimer = setTimeout(() => this.swapImage(link), 60);
//           });
//           link.addEventListener('mouseleave', () => {
//             clearTimeout(this.swapTimer);
//           });
//         }

//         link.addEventListener('click', (event) => {
//           // Swallow clicks arriving right after open — they were aimed at the button.
//           if (Date.now() - (this.openedAt || 0) < 400) {
//             event.preventDefault();
//             return;
//           }
//           // Touch: first tap previews, second tap on the same slide navigates.
//           if (!this.hoverCapable && this.activeLink !== link) {
//             event.preventDefault();
//             this.activeLink = link;
//             this.swapImage(link);
//           }
//         });
//       });
//     }

//     open() {
//       if (!this.wrap.hidden) return;
//       this.openedAt = Date.now();
//       this.toggle.hidden = true;
//       this.wrap.hidden = false;

//       if (this.swiper) {
//         this.swiper.update();
//         return;
//       }
//       this.initSwiper();
//     }

//     initSwiper() {
//       if (this.swiper) return;

//       if (typeof Swiper === 'undefined') {
//         // Swiper not loaded yet (theme loads it later / async) — retry briefly.
//         this.swiperRetries = (this.swiperRetries || 0) + 1;
//         if (this.swiperRetries > 20) {
//           console.warn('[color-slider] Swiper is not defined — check that swiper-bundle.js is loaded before card-color-slider.js');
//           return;
//         }
//         setTimeout(() => {
//           if (!this.wrap.hidden) this.initSwiper();
//         }, 100);
//         return;
//       }

//       // Lazy init: Swiper measures wrong inside a hidden container.
//       this.swiper = new Swiper(this.swiperEl, {
//         slidesPerView: 'auto',
//         spaceBetween: 20,
//         freeMode: true,
//         watchOverflow: true,
//         mousewheel: {
//           forceToAxis: false,
//           releaseOnEdges: true
//         },
//         navigation: {
//           prevEl: this.prev,
//           nextEl: this.next
//         }
//       });
//     }

//     close() {
//       clearTimeout(this.swapTimer);
//       this.activeLink = null;
//       this.wrap.hidden = true;
//       this.toggle.hidden = false;
//       this.restoreImage();
//     }

//     swapImage(link) {
//       if (!this.cardImg) return;
//       this.cardImg.setAttribute('src', link.dataset.imageSrc);
//       this.cardImg.setAttribute('srcset', link.dataset.imageSrcset || link.dataset.imageSrc);
//       if (this.cardWrapper) this.cardWrapper.classList.add('color-swap-active');
//     }

//     restoreImage() {
//       if (!this.cardImg || !this.orig) return;
//       this.cardImg.setAttribute('src', this.orig.src);
//       if (this.orig.srcset) this.cardImg.setAttribute('srcset', this.orig.srcset);
//       if (this.cardWrapper) this.cardWrapper.classList.remove('color-swap-active');
//     }
//   }

//   customElements.define('color-slider', ColorSlider);
// })();
/**
 * card-color-slider.js
 * Global custom element for the "N colors" mini slider in product cards.
 * Include ONCE in layout/theme.liquid:
 *   <script src="{{ 'card-color-slider.js' | asset_url }}" defer="defer"></script>
 * Must load AFTER Swiper (or Swiper must also be deferred and included earlier).
 */
(() => {
  if (customElements.get('color-slider')) return;

  class ColorSlider extends HTMLElement {
    connectedCallback() {
      // Guard against upgrade-before-children-parsed (streaming parser)
      // and against re-connection after AJAX re-render.
      if (this.initialized) return;
      if (!this.querySelector('.card-color-slider__toggle')) {
        document.addEventListener('DOMContentLoaded', () => this.init(), { once: true });
        return;
      }
      this.init();
    }

    init() {
      if (this.initialized) return;
      this.initialized = true;

      this.toggle = this.querySelector('.card-color-slider__toggle');
      this.wrap = this.querySelector('.card-color-slider__wrap');
      this.swiperEl = this.querySelector('.card-color-slider__swiper');
      this.prev = this.swiperEl.querySelector('.swiper-button-prev');
      this.next = this.swiperEl.querySelector('.swiper-button-next');
      this.cardWrapper = this.closest('.card-wrapper');
      this.cardImg = this.cardWrapper
        ? this.cardWrapper.querySelector('.card__media .media img')
        : null;
      // Theme's secondary (hover) image, if show_secondary_image rendered it.
      this.cardImg2 = this.cardWrapper
        ? this.cardWrapper.querySelector('.card__media .media img + img')
        : null;

      if (this.cardImg) {
        this.orig = {
          src: this.cardImg.getAttribute('src'),
          srcset: this.cardImg.getAttribute('srcset')
        };
      }
      if (this.cardImg2) {
        this.orig2 = {
          src: this.cardImg2.getAttribute('src'),
          srcset: this.cardImg2.getAttribute('srcset')
        };
      }

      // Real hover only. On touch devices the browser emulates
      // mouseenter right before click — opening here would make the tap's
      // click land on the slide that replaced the button.
      this.hoverCapable = window.matchMedia('(hover: hover)').matches;

      this.toggle.addEventListener('click', () => this.open());
      if (this.hoverCapable) {
        this.toggle.addEventListener('mouseenter', () => this.open());
      }

      // Anti-jitter: delayed close, cancelled if the cursor comes right back.
      this.addEventListener('mouseleave', () => {
        this.closeTimer = setTimeout(() => this.close(), 150);
      });
      this.addEventListener('mouseenter', () => {
        clearTimeout(this.closeTimer);
      });

      this.querySelectorAll('.card-color-slider__item').forEach((link) => {
        // Anti-jitter: swap only if the cursor actually rests on a slide.
        if (this.hoverCapable) {
          link.addEventListener('mouseenter', () => {
            this.swapTimer = setTimeout(() => this.swapImage(link), 60);
          });
          link.addEventListener('mouseleave', () => {
            clearTimeout(this.swapTimer);
          });
        }

        link.addEventListener('click', (event) => {
          // Swallow clicks arriving right after open — they were aimed at the button.
          if (Date.now() - (this.openedAt || 0) < 400) {
            event.preventDefault();
            return;
          }
          // Touch: first tap previews, second tap on the same slide navigates.
          if (!this.hoverCapable && this.activeLink !== link) {
            event.preventDefault();
            this.activeLink = link;
            this.swapImage(link);
          }
        });
      });
    }

    open() {
      if (!this.wrap.hidden) return;
      this.openedAt = Date.now();
      this.toggle.hidden = true;
      this.wrap.hidden = false;

      if (this.swiper) {
        this.swiper.update();
        return;
      }
      this.initSwiper();
    }

    initSwiper() {
      if (this.swiper) return;

      if (typeof Swiper === 'undefined') {
        // Swiper not loaded yet (theme loads it later / async) — retry briefly.
        this.swiperRetries = (this.swiperRetries || 0) + 1;
        if (this.swiperRetries > 20) {
          console.warn('[color-slider] Swiper is not defined — check that swiper-bundle.js is loaded before card-color-slider.js');
          return;
        }
        setTimeout(() => {
          if (!this.wrap.hidden) this.initSwiper();
        }, 100);
        return;
      }

      // Lazy init: Swiper measures wrong inside a hidden container.
      this.swiper = new Swiper(this.swiperEl, {
        slidesPerView: 'auto',
        spaceBetween: 20,
        freeMode: true,
        watchOverflow: true,
        mousewheel: {
          forceToAxis: false,
          releaseOnEdges: true
        },
        navigation: {
          prevEl: this.prev,
          nextEl: this.next
        }
      });
    }

    close() {
      clearTimeout(this.swapTimer);
      this.activeLink = null;
      this.wrap.hidden = true;
      this.toggle.hidden = false;
      this.restoreImage();
    }

    swapImage(link) {
      if (!this.cardImg) return;
      this.cardImg.setAttribute('src', link.dataset.imageSrc);
      this.cardImg.setAttribute('srcset', link.dataset.imageSrcset || link.dataset.imageSrc);

      if (this.cardImg2 && link.dataset.image2Src) {
        // Hovered color has its own secondary image — swap it in,
        // keep the theme's hover effect alive.
        this.cardImg2.setAttribute('src', link.dataset.image2Src);
        this.cardImg2.setAttribute('srcset', link.dataset.image2Srcset || link.dataset.image2Src);
        if (this.cardWrapper) this.cardWrapper.classList.remove('color-swap-active');
      } else if (this.cardWrapper) {
        // No secondary image for this color — suppress the stale one.
        this.cardWrapper.classList.add('color-swap-active');
      }
    }

    restoreImage() {
      if (!this.cardImg || !this.orig) return;
      this.cardImg.setAttribute('src', this.orig.src);
      if (this.orig.srcset) this.cardImg.setAttribute('srcset', this.orig.srcset);
      if (this.cardImg2 && this.orig2) {
        this.cardImg2.setAttribute('src', this.orig2.src);
        if (this.orig2.srcset) this.cardImg2.setAttribute('srcset', this.orig2.srcset);
      }
      if (this.cardWrapper) this.cardWrapper.classList.remove('color-swap-active');
    }
  }

  customElements.define('color-slider', ColorSlider);
})();
 }, false);
})();
